<template>
  <v-app class="root" :dark="isThemeDark">
    <TheToolbar v-if="$route.path.indexOf('auth') === -1" :is-theme-dark="isThemeDark" @themeChanged="toggleTheme" />
    <TheDrawer v-if="$route.path.indexOf('auth') === -1" :links="links" />
    <v-content app>
      <v-snackbar :timeout="0" color="green" :value="success">Успешно</v-snackbar>
      <v-snackbar auto-height color="red" :value="error">
        <div v-html="error" />
      </v-snackbar>
      <v-container class="admin__content">
        <v-card>
          <v-progress-linear
            v-if="load"
            color="primary"
            height="2"
            indeterminate
          />
          <v-card-title class="title">{{ title || $route.meta.title }}</v-card-title>
          <v-divider />
          <v-card-text class="text-block">
            <router-view :key="$route.path" :selectedUser="selectedUser" @title_changed="title = $event" />
          </v-card-text>
        </v-card>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import User from '../helpers/user'
import { getAuthUser } from '../api/auth'
import WebSockets from '@/sockets/WebSockets'


export default {
  data: () => ({
    i: 'asfdgadsgafds',
    selectedUser: null,
    title: null,
    links: [
      {
        title: 'Главная страница', icon: 'home', href: { name: 'index' }
      },
      {
        title: 'Игры', icon: 'casino', href: { name: 'games' }
      },
      {
        title: 'Пользователи', icon: 'people', href: { name: 'users' }
      },
      {
        title: 'Реф. программа',
        icon: 'star_border',
        href: { name: 'referal' }
      },
      {
        title: 'Транзакции', icon: 'payments', href: { name: 'transactions' }
      },
      {
        title: 'Trust Points', icon: 'verified_user', href: { name: 'trust-points' }
      },
      {
        title: 'Выплаты', icon: 'attach_money', href: { name: 'payouts' }
      },
      {
        title: 'Чат',
        icon: 'question_answer',
        href: { name: 'game-chat' }
      },
      {
        title: 'Промокоды', icon: 'local_offer', href: { name: 'promocodes' }
      },
      {
        title: 'Розыгрыши', icon: 'money', href: { name: 'lotteries' }
      },
      {
        title: 'Мультидомены', icon: 'link', href: { name: 'multidomen' }
      },
      {
        title: 'Платежные системы', icon: 'payments', href: { name: 'payment-system' }
      }
    ],
    isThemeDark: false
  }),
  computed: {
    ...mapGetters(['success', 'error', 'load']),
    user () {
      return this.$store.getters.user
    }
  },
  watch: {
    '$route.fullPath': function () {
      this.title = null
    },
    user (n, o) {
      const exists = this.links.some(link => link.href
        && link.href.name === 'logs')
      const existsRights = this.links.some(link => link.href
        && link.href.name === 'rights')

      if (n !== null && User.hasAdminAccess() && !exists)
        this.links.push({
          title: 'Логи пользователя',
          icon: 'format_list_bulleted',
          href: { name: 'logs' }
        })

      if (n !== null && User.isSuperAdmin() && !existsRights)
        this.links.push({
          title: 'Права доступа',
          icon: 'lock',
          href: { name: 'rights' }
        })

      if ((n === null || !User.hasAdminAccess()) && exists)
        this.links = this.links.filter(
          link => !(link.href && link.href.name === 'logs')
        )

      if ((n === null || !User.isSuperAdmin()) && existsRights)
        this.links = this.links.filter(
          link => !(link.href && link.href.name === 'rights')
        )
    }
  },

  created () {
    WebSockets.subscribe('signature_hash_key', key => {
      this.$store.commit('setSignatureKey', key)
    })

    if (User.isAuth())
      getAuthUser()
        .then(response => {
          this.$store.commit('SET_AUTH_USER', response.data)
          User.setRoles(response.data.roles.map(item => item.name))
          this.$router.go(-1)
        })
        .catch(error => {
          User.signOut()
          this.$router.push('/auth')
        })
  },
  mounted () {
    this.isThemeDark = JSON.parse(localStorage.getItem('isThemeDark')) || false
    EventBus.$on('chat-user', data => {
      this.selectedUser = data
    })
  },
  methods: {
    toggleTheme () {
      this.isThemeDark = !this.isThemeDark
      localStorage.setItem('isThemeDark', JSON.stringify(this.isThemeDark))
      EventBus.$emit('theme-changed', this.isThemeDark)
    }
  }
}
</script>

<style lang="scss">
    .root{
        --brand: #10BAA8;
        --brand-transparent: #10BAA877;
    }

    @import "~vuetify/dist/vuetify.min.css";

    .admin__content {
        max-width: 100%;
        padding-top: 30px;
        padding-bottom: 100px;
    }

    .field {
        display: inline-block;
        margin: 0 8px;
    }

    .text-block {
        span {
            margin-bottom: 11px;
            display: inline-block;
            font-weight: 400;
            font-size: 20px;
            line-height: 1;
            letter-spacing: 0.02em;
            font-family: Roboto, sans-serif;
        }
    }

    @for $i from 0 through 10 {
        .side-btn-#{$i} {
            position: absolute;
            bottom: 15px;
            right: #{$i * 90 - 180}px;
        }
    }
</style>
